define(function(require) {
	// general
	const constants = require('civicsUtils/constants');
	const utils = require('civicsUtils/general_utilities');
	const ViewManager = require('civicsUtils/view_manager');
	// models
	const ApplicationModel = require('civicsModels/application_model');
	// templates
	const tpl = require('./templates/t_itv_parent_instrument_summary.hbs');
	const TypeUtils = require('civicsUtils/type_utilities');

	return Marionette.ItemView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.config.id = options.id;
			this.config.instrumentNumber = options.instrumentNumber;
			this.config.instrumentType = options.instrumentType;
			this.config.globalConfig = ViewManager.globalConfig().toJSON();
			this.applicantTypesPromise = $.Deferred();
			this.applicationModelFetched = $.Deferred();
			this.typeUtils = TypeUtils;

			this.loadApplicantTypes(options.parentTypeUtils);
			if (options.tpl) {
				this.template = options.tpl;
			} else {
				this.template = tpl;
			}

			//Trade license does not have sites.
			if( options.instrumentType.toLowerCase() == "tradelicense"){
				this.config.show.location = false;
			}


			this.config.show.Any = this.config.show.parent || this.config.show.location || this.config.show.contacts;
			ViewManager.loading(true);
			this.model = new ApplicationModel();
			if(!options.applicationModel){
				this.model.set('id', options.id); 
				this.model.formatUrlRoot(options.instrumentType);
				if (__DEV__) console.log('itv_parent_instrument_summary initialize -- urlRoot: ', this.model.urlRoot);
				this.applicationModelFetched = this.model.fetch();
			}else{
				this.model = options.applicationModel;
				this.applicationModelFetched.resolve();
			}
		},
		className: 'v_itv_parent_instrument_summary',
		onRender:function(){
			if(__DEV__) console.log('itv_parent_instrument_summary -- onRender');
		},
		onShow:function(){
			var self = this;
			if(__DEV__) console.log('itv_parent_instrument_summary -- onShow');

			$.when(
				this.applicationModelFetched,
				this.applicantTypesPromise)
			 	.done(function() {
					if (__DEV__) console.log('itv_parent_instrument_summary initialize -- fetch done');

					var type = this.options.instrumentType.toLowerCase();
					var instType = {
						building:(type == 'buildingpermit' || type == 'building'),
						businesslicense:(type == 'businesslicense' || type == 'license'),
						tradelicense:(type == 'tradelicense'),
						use:(type == 'use' || type == 'use'),
						codeenforcement:(type == 'codeenforcement'),
						project:(type == 'project'),
						planning:(type == 'planning'),
						servicerequest:(type == 'servicerequest')
					};
					this.options.instType = instType;

					// separate primary contact
					var contacts = this.model.get('applicationContacts');
					var contactModels = (contacts && contacts.models) ? contacts.models : [];
					var additionalContacts = [];
					var j = 0;

					for (var i = 0; i < contactModels.length; i++) {
						var model = contactModels[i];
						var capacity = self.getCapacity(model);
						var contact = {
							name: model.get('contact.identity.firstName') + ' ' + model.get('contact.identity.lastName'),
							contactType: this.config.globalConfig.usesApplicantType == 'Show' ? model.get('contactType') : '',
							capacity: capacity
						}
						if (model.get('isPrimary') != 'True') {
							additionalContacts[j++] = contact;
						}
						else{
							if( this.config.globalConfig.usesCapacity != 'Hide' ){
								self.model.set('primaryContactCapacity', capacity);
							}
							if( this.config.globalConfig.usesApplicantType == 'Hide' ){
								self.model.unset('primaryContactType', {silent:true});
							}
						}
					}
					this.model.set('additionalContacts', additionalContacts);

					//Need to handle the Location Line 1 for roperties
					var locLine1 = this.model.get("locationLine1");
					if( this.model.get("property") && this.model.get("property").get("id") > 1 ){
						let propertyName = this.model.get("property").get("propertyName");
						if( propertyName && propertyName != '' && propertyName != ' ')
							locLine1 = propertyName;
						else
							locLine1 = this.model.get("property").get("propertyId");
						this.model.set("locationLine1", locLine1);
					}

			 		// Need to call render so that handlebar helpers work
			 		// e.g.  In cases where a helper must be evaluated after something changes
			 		// in onShow
			 		this.render();
					ViewManager.loading(false);
			 	}.bind(this))
			 	.fail(function(response, status, xhrResponse) {
			 		if(__DEV__) console.log('itv_parent_instrument_summary -- failed to get data');
			 		ViewManager.errorToWindow(response);
			 	});
		},
		loadApplicantTypes: function(parentTypeUtils){
			if (this.config.instrumentType !=null && this.config.instrumentType.toLowerCase() != "tradelicense" && this.config.globalConfig.usesApplicantType !=null && this.config.globalConfig.usesApplicantType.toLowerCase() == 'show') {
				let loadTypesPromise = $.Deferred();
				if(!parentTypeUtils){
					loadTypesPromise = this.typeUtils.fetchApplicantTypes(this.config.instrumentType);
				}else{
					this.typeUtils = parentTypeUtils;
					loadTypesPromise.resolve();
				}
				
				$.when(loadTypesPromise).done(()=>{
					let types = this.typeUtils.getApplicantTypes(this.config.instrumentType);
					this.applicantTypes = types;
					this.applicantTypesPromise.resolve();
				 });
			} else {
				this.applicantTypesPromise.resolve();
			}
		},
		templateHelpers: function() {
			var self = this;
			return {
				show: this.config.show,
				parentLinkClasses: (self.model?.get?.('applicationType.showInPortal') ? "" : "disabled"),
				parentAvailableOnline: (self.model?.get?.('applicationType.showInPortal') ? self.model?.get?.('applicationType.showInPortal') : false),
                intDetailTargetPage: function() {
                	if (typeof self.config.intDetailTargetPage == 'undefined') {
                		return 'error_no_target_page_defined';
                	}
                	return self.config.intDetailTargetPage.urlPath({intdetails:self.config.instrumentType,intid:self.config.id});
                },
				filteredAssociatedProperties: function () {
					var filteredAssociatedProperties = [];
					if (typeof self.model.get('associatedProperties') != 'undefined') {
						filteredAssociatedProperties = self.model.get('associatedProperties').toJSON().filter(function (el) {
							if( el.parcel > 1){
								el.locationLine1 = el.description;
							}
							// Address sites only carry formatted location lines when the
							// server binds them (a direct application fetch).  Child-record
							// endpoints such as hearings embed the application without those
							// lines, so fall back to the description -- which always holds
							// the formatted address -- when locationLine1 is absent. HPS-142146.
							else if( el.address > 1 && !el.locationLine1 ){
								el.locationLine1 = el.description;
							}
							return el.isLinked == false && (el.address > 1 || el.parcel > 1);
						});
					}
					return filteredAssociatedProperties;
				},
				getContactPosition: function (code) {
					code = parseInt(code);
					return self.typeUtils.getApplicantTypeDesc(code, self.options.instrumentType, self.applicantTypes);
				},
				useContact: (this.options.instType && this.options.instType.codeenforcement) ? true : false,
				instrumentNumber: this.config.instrumentNumber ? this.config.instrumentNumber : this.config.id,
				applicationTypeDescription: function () {
					if (typeof self.model.get('applicationType') != 'undefined') {
						var compDesc = Handlebars.helpers['global:computedDescription'](self.model.get('applicationType').get('portalDescription'), self.model.get('applicationType').get('description'));
						return Handlebars.helpers['global:limitLength'](compDesc, 300);
					}
				}
			};
		},
		getCapacity: function (contactModel){
			var capacity = '';
			if( this.config.globalConfig.usesCapacity == 'Hide' ){
				return '';
			}
			else {
				if( contactModel.get('capacity') && contactModel.get('capacity').get('code')){
					if( contactModel.get('capacity').get('code').trim().length > 0 ){
						capacity = contactModel.get('capacity').get('description').trim().length > 0 ? contactModel.get('capacity').get('description') : i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
					}
				}
			}
			return capacity;
		}
	});
});
